import * as React from "react";
const SvgFiRrGuaraniSign = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.39 12.21A3 3 0 0 0 18.98 11H13V4.06c2.65.32 4.97 1.94 6.18 4.39a1 1 0 1 0 1.79-.89A9.95 9.95 0 0 0 13 2.05V1c0-.55-.45-1-1-1s-1 .45-1 1v1.05C5.96 2.56 2.01 6.83 2.01 12s3.95 9.45 8.99 9.95V23c0 .55.45 1 1 1s1-.45 1-1v-1.05c4.1-.41 7.73-3.27 8.87-7.11.27-.91.1-1.87-.47-2.63zM4.01 12c0-4.07 3.05-7.44 6.99-7.94v15.87c-3.93-.49-6.99-3.86-6.99-7.94zm15.94 2.27c-.89 3.01-3.72 5.27-6.95 5.66v-6.94h5.98a1 1 0 0 1 .81.41c.19.25.25.57.16.87"
    />
  </svg>
);
export default SvgFiRrGuaraniSign;
